function BloodTestIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M18.6837 12.7281L11.8582 9.09264L3.85082 24.1264C2.94211 25.8325 3.58852 27.9522 5.2946 28.8609L5.94183 29.2056C7.64791 30.1143 9.76762 29.4679 10.6763 27.7619L18.6837 12.7281ZM11.0332 6.38721L2.0856 23.1862C0.657629 25.8672 1.6734 29.1982 4.35439 30.6261L5.00162 30.9709C7.68261 32.3988 11.0136 31.3831 12.4416 28.7021L21.3892 11.9031L11.0332 6.38721Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.6629 4.68687L11.5347 6.80513L20.7634 11.7206L21.8917 9.60237L12.6629 4.68687ZM12.7205 2.45155C12.233 2.19192 11.6274 2.3766 11.3678 2.86406L9.29934 6.74754C9.03971 7.23499 9.2244 7.84062 9.71185 8.10025L20.7058 13.956C21.1933 14.2156 21.7989 14.0309 22.0586 13.5435L24.127 9.65997C24.3866 9.17252 24.202 8.56689 23.7145 8.30725L12.7205 2.45155Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M28.8907 23.5845C29.3478 22.5543 29.5 21.9158 29.5 21.6562C29.5 19.8546 28.0993 18.5 26.5 18.5C24.9007 18.5 23.5 19.8546 23.5 21.6562C23.5 21.9158 23.6522 22.5543 24.1093 23.5845C24.5332 24.5396 25.1145 25.6057 25.7196 26.6248C25.9835 27.0691 26.2478 27.4978 26.5 27.8966C26.7522 27.4978 27.0165 27.0691 27.2804 26.6248C27.8855 25.6057 28.4668 24.5396 28.8907 23.5845ZM27.7022 29.7253C29.1816 27.4579 31.5 23.5954 31.5 21.6562C31.5 18.8085 29.2614 16.5 26.5 16.5C23.7386 16.5 21.5 18.8085 21.5 21.6562C21.5 23.5954 23.8184 27.4579 25.2978 29.7253C25.991 30.7878 26.5 31.5 26.5 31.5C26.5 31.5 27.009 30.7878 27.7022 29.7253Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}

export default BloodTestIcon;
